import { memo } from "react";
import { Fragment, h } from "preact";
import { useController, UseControllerProps } from "react-hook-form";
import { compareRender } from "../../../functions/form";
import { Row, Select as SelectAntd } from "antd";
import { Text } from "../../text";
import { useMemo } from "preact/hooks";
import { Required, RowComponent } from "../../../style/styled";

const { Option } = SelectAntd;

interface IProperties {
  options: any[];
  valueKey?: string;
  labelKey?: string;
}

interface IItem extends UseControllerProps {
  ref: string;
  id: string;
  format?: string;
  label?: string;
  labelExtra?: any;
  placeholder?: string;
  mode: "multiple";
  properties: IProperties;
  disabled?: boolean;
  dropdownClassName?: string;
}
interface ISelect {
  control?: any;
  item: IItem;
  handleChange: (e: any, item: IItem) => null;
  handleClear: (e: any, item: IItem) => null;
}

const Select = ({ control, item, handleChange, handleClear }: ISelect) => {
  const {
    ref,
    rules,
    name,
    defaultValue,
    placeholder,
    label,
    labelExtra,
    mode,
    disabled,
    properties,
    dropdownClassName,
  } = item;
  const { options, valueKey, labelKey } = properties;
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  });
  const { error } = fieldState;
  const { value } = field;

  const opt = useMemo(() => {
    return options.map((e) => {
      const val = valueKey ? e[valueKey] : e;
      const lab = labelKey ? e[labelKey] : e;
      return <Option value={val}>{lab}</Option>;
    });
  }, [options]);

  return (
    <>
      <RowComponent>
        {label &&
          ((<Text size={"XS"} text={label} bold={true} />) as React.ReactNode)}
        {labelExtra && (labelExtra as React.ReactNode)}
        {rules && rules.required && <Required>*</Required>}
      </RowComponent>
      <SelectAntd
        showSearch
        showArrow
        allowClear
        id={ref}
        onClear={() => handleClear({}, item)}
        value={value || []}
        placeholder={placeholder}
        optionFilterProp="children"
        onChange={(e) => handleChange(e, item)}
        style={{ width: "100%" }}
        mode={mode || undefined}
        disabled={disabled}
        dropdownClassName={dropdownClassName}
      >
        {opt as React.ReactNode}
      </SelectAntd>
      <Row>
        {error &&
          ((
            <Text size={"XS"} text={error.message} color="red" bold />
          ) as React.ReactNode)}
      </Row>
    </>
  );
};

export const MemoizedSelect = memo(
  Select,
  (prev, next) =>
    compareRender(prev, next) &&
    JSON.parse(JSON.stringify(prev.item.properties.options)) ===
      JSON.parse(JSON.stringify(next.item.properties.options)) &&
    compareRender(prev, next, "item.disabled")
);
